import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class PdsDxDateService {
    public formatAsAuDate: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("DD/MM/YYYY");
    }
    public formatAsAuDateTime: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("DD/MM/YYYY HH:mm");
    }
    public formatAsAuDateTimeWithSec: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("DD/MM/YYYY HH:mm:ss");
    }
    public formatAsLocalAuDateTime: any = function (value: any) {
        let resultDate = moment(value).local().toDate();
        return moment(resultDate).format("DD/MM/YYYY HH:mm");
    }
    /*public formatAsAuDateTimeLocal: any = function (value: any) {
        return moment(value).add(moment().utcOffset(), 'm').format("DD/MM/YYYY HH:mm");
    }*/
    public getAsLocalDateTime(value: Date): Date {
        return moment(value).local().toDate();
    }
    public formatAsAuShortDate: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("DD/MM/YY")
    }
    public formatAsAuVeryShortDate: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("DD/MM")
    }
    public formatAsAuVeryShortDateTime: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("DD/MM HH:mm")
    }
    public formatAsAuVeryShortTimeDate: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("HH:mm DD/MM")
    }
    public formatAsLocalAuVeryShortTimeDate: any = function (value: any) {
        //debugger;
        return moment.utc(value).local().format("HH:mm DD/MM")
    }
    public formatAsDay: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("dddd");
    }
    public formatAsDayAuDate: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("dddd DD/MM/YYYY");
    }
    public formatAs24HourTime: any = function (value: any) {
        let resultDate = new Date(value);
        return moment(resultDate).format("HH:mm");
    }
    public parseAsAuDate(e: string) {
        var parts = e.split("/"),
            day = Number(parts[0]),
            month = Number(parts[1]) - 1,
            year = Number(parts[2]);

        return new Date(year, month, day);
    }
    public parseAsAuDateTime(e: string) {
        var parts = e.split("/"),
            day = Number(parts[0]),
            month = Number(parts[1]) - 1,
            year = Number(parts[2]);

        return new Date(year, month, day);
    }
    public parseAsAuDateTimeOffset(e: any) {
        let a = moment(e, 'DD/MM/YYYY HH:mm');
        a = a.local();
        return a.toDate();
    }
    public parseAs24HourTime(e: string) {
        var parts = e.split(":"),
            hours = Number(parts[0]),
            minutes = Number(parts[1]);
        return new Date(1900, 1, 1, hours, minutes);
    }
    public getDateAsApiString(date: Date): string {
        let aDate: string = moment(date).format("YYYY-MM-DD");
        return aDate;
    }
    public getTimeAsApiString(date: Date): string {
        let aDate: string = moment(date).format("HH:NN");
        return aDate;
    }
    public getApiDate(date: string): Date {
        return moment(date).toDate();
    }
}